import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';

import {useAuth} from '../../../context/authContext';
import {getPersianErrorCode} from '../../../global/helpers/ErrorCodes/ErrorCode';
import {ErrorResponse} from '../patchDirectLoanRequest/usePatchDirectLoanRequest';
import {postDirectLoanRequest} from './postLoanRequest';

const usePostDirectLoanRequest = () => {
  const navigate = useNavigate();
  const {supplierProfile} = useAuth();

  const reRouteURL = supplierProfile?.state
    ? `/city-contract-stores/${supplierProfile?.state}`
    : '/my-credits/startLoanCredit';

  const {mutate, isLoading} = useMutation({
    mutationFn: () => postDirectLoanRequest(),

    onError: (error: AxiosError<ErrorResponse>) => {
      const errorCode = error.response?.data?.error_code;

      if (errorCode) {
        toast.error(getPersianErrorCode(errorCode));

        return;
      }

      if (error?.response?.status === 404) {
        navigate(reRouteURL, {
          replace: true,
          state: {
            show404Toast: true,
          },
        });
      }
    },
  });

  return {mutate, isLoading};
};

export default usePostDirectLoanRequest;
